<wiz-vgroup width="100%" height="100%" class="tile-shadow" gap="0">
  <wiz-hgroup
    width="100%"
    height="35px"
    verticalAlign="center"
    padding="3px"
    gap="2"
    style="cursor: pointer"
    (click)="selectMe($event)"
    [class.error-class]="hasError"
    [class.tile-header]="!hasError"
  >
    <wiz-label #lbTitle width="100%" style="font-size: 12px;" [wizLabel]="data.shortCode" [wizTextBehavior]="'truncate'"></wiz-label>
    <wiz-icon
      [class.invisible-class]="!hasHiddenDependencies"
      (click)="showDependencies($event)"
      [wizTooltip]="'$.measure.show.dependencies.$'" style="font-size: 16px;"
      >arrow-left</wiz-icon
    >
    <wiz-icon (click)="doClose($event)" [wizTooltip]="'$.measure.show.hide.$'" style="font-size: 16px;">close</wiz-icon>
    <wiz-icon
      [class.invisible-class]="!hasHiddenLegacies"
      (click)="showLegacies($event)"
      [wizTooltip]="'$.measure.show.legacies.$'" style="font-size: 16px;"
      >arrow-right</wiz-icon
    >
  </wiz-hgroup>
  <wiz-group
    class="tile-body"
    width="100%"
    height="100%"
    style="cursor: pointer"
    (dblclick)="quickFormula($event)"
    verticalAlign="center"
    horizontalAlign="center"
  >
    <wiz-vgroup width="100%"  height="100%" gap="0">
      <wiz-hgroup verticalAlign="center">
        <wiz-icon *ngIf="showPen" class="image-inactive" [wizTooltip]="'$.measure.kind.editable.$'">edit</wiz-icon>
        <wiz-icon *ngIf="showWeight" class="image-inactive" [wizTooltip]="'$.measure.kind.weight.$'">weight-grid</wiz-icon>
        <wiz-icon *ngIf="showConstant" class="image-inactive" [wizTooltip]="'$.measure..kind.constant.$'">constant</wiz-icon>
        <wiz-label   [wizLabel]="data.trsLabel"  width="100%"  padding="3px" [wizTextBehavior]="'wordWrap'"></wiz-label>
      </wiz-hgroup>

      <wiz-label #lbContent style="font-size: 9px;" [wizLabel]="currentFormula"  width="100%"  padding="3px"  [wizNbLine]="3"  [wizTextBehavior]="'wordWrap'" *ngIf="!showPen"></wiz-label>

    </wiz-vgroup>

  </wiz-group>
</wiz-vgroup>
